<div
  class="buttons-container"></div>
<div class="container">
  <h2 class="content-block">Hakkımızda</h2>

  <div class="content-block card responsive-paddings">


    <label span class="dx-field-item-label-text">Başlık</label>
    <dx-text-box
      [(value)]="staticPageUpdateDto.title"
      labelMode="floating"
      [maxLength]="100"
    >
    </dx-text-box>
    <br />
    <label span class="dx-field-item-label-text">MetaKeyword</label>
    <dx-text-box
      [(value)]="staticPageUpdateDto.metaKeyword"
      labelMode="floating"
    >
    </dx-text-box>
    <br />
    <label span class="dx-field-item-label-text">MetaDescription</label>
    <dx-text-box
      [(value)]="staticPageUpdateDto.metaDescription"
      labelMode="floating"
    >
    </dx-text-box>
    <br />
    <app-image-uploader
      (fileSelected)="onFileSelected($event)"
      [src]="staticPageUpdateDto.imageUrl"
    ></app-image-uploader>
    <br />
    <dx-html-editor
      [(value)]="staticPageUpdateDto.content"
    >
      <dxo-toolbar>
        <dxi-item name="undo"></dxi-item>
        <dxi-item name="redo"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item
          name="size"
          [acceptedValues]="[
            '8pt',
            '9pt',
            '10pt',
            '12pt',
            '14pt',
            '18pt',
            '24pt',
            '36pt'
          ]"
          [options]="{ inputAttr: { 'aria-label': 'Font size' } }"
        ></dxi-item>
        <dxi-item
          name="font"
          [acceptedValues]="[
            'Arial',
            'Courier New',
            'Georgia',
            'Impact',
            'Lucida Console',
            'Tahoma',
            'Times New Roman',
            'Verdana'
          ]"
          [options]="{ inputAttr: { 'aria-label': 'Font family' } }"
        ></dxi-item>
        <dxi-item
          name="header"
          [acceptedValues]="[false, 1, 2, 3, 4, 5]"
          [options]="{ inputAttr: { 'aria-label': 'Header' } }"
        ></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="bold"></dxi-item>
        <dxi-item name="italic"></dxi-item>
        <dxi-item name="strike"></dxi-item>
        <dxi-item name="underline"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="alignLeft"></dxi-item>
        <dxi-item name="alignCenter"></dxi-item>
        <dxi-item name="alignRight"></dxi-item>
        <dxi-item name="alignJustify"></dxi-item>
        <dxi-item name="orderedList"></dxi-item>
        <dxi-item name="bulletList"></dxi-item>
        <dxi-item name="separator"></dxi-item>
        <dxi-item name="link" [options]="{ undoEnabled: true }"></dxi-item>
        <dxi-item widget="dxButton" [options]="toolbarButtonOptions"></dxi-item>
      </dxo-toolbar>
    </dx-html-editor>

    <div class="city">
      <dx-button
        icon="save"
        type="success"
        text="Kaydet"
        class="margin"
        (onClick)="save()"
      ></dx-button>
    </div>

    <dx-popup
      [showTitle]="true"
      title="Ön İzleme"
      [(visible)]="popupVisible"
      [showCloseButton]="true"
    >
      <h3>{{ staticPageUpdateDto.title }}</h3>
      <div [innerHTML]="staticPageUpdateDto.content"></div>
    </dx-popup>
  </div>
</div>


